import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function Cursor() {
    const [pos, setPos] = useState({ x: -100, y: -100 });
    const [active, setActive] = useState(false);
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        const fine = window.matchMedia("(pointer: fine)").matches;
        const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (!fine || reduced) return;
        setEnabled(true);
        const move = (e) => {
            setPos({ x: e.clientX, y: e.clientY });
            setActive(!!e.target.closest("a,button,[data-cursor='plus']"));
        };
        window.addEventListener("mousemove", move, { passive: true });
        return () => window.removeEventListener("mousemove", move);
    }, []);

    if (!enabled) return null;

    return (
        <motion.div
            aria-hidden="true"
            className="pointer-events-none fixed left-0 top-0 z-[90] hidden md:flex items-center justify-center"
            animate={{ x: pos.x - 16, y: pos.y - 16 }}
            transition={{ type: "spring", stiffness: 500, damping: 40, mass: 0.4 }}
        >
            {active ? (
                <span className="font-display text-[#D60024] text-3xl leading-none">+</span>
            ) : (
                <span className="block h-8 w-8 rounded-full border border-white/40 mix-blend-difference" />
            )}
        </motion.div>
    );
}
